import { useTranslation } from "react-i18next";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TermsContent } from "@/pages/legal/Terms";
import { PrivacyContent } from "@/pages/legal/Privacy";

const DOCS = {
  terms: { title: "register.termsModalTitle", href: "/terms", Content: TermsContent },
  privacy: { title: "register.privacyModalTitle", href: "/privacy", Content: PrivacyContent },
};

export function LegalDialog({ doc, onClose, onAccept }) {
  const { t } = useTranslation();
  const cfg = doc ? DOCS[doc] : null;
  return (
    <Dialog open={!!cfg} onOpenChange={(o) => !o && onClose()}>
      {cfg && (
        <DialogContent data-testid={`legal-modal-${doc}`}
          className="flex h-[100dvh] max-h-[100dvh] max-w-full flex-col gap-0 rounded-none p-0 sm:h-auto sm:max-h-[85vh] sm:max-w-[920px] sm:rounded-2xl">
          <DialogHeader className="border-b border-slate-200 bg-white px-5 py-4 pr-12 text-left sm:px-8">
            <DialogTitle className="font-heading text-xl font-extrabold text-navy sm:text-2xl">{t(cfg.title)}</DialogTitle>
            <DialogDescription className="sr-only">{t(cfg.title)}</DialogDescription>
          </DialogHeader>
          <div className="flex-1 space-y-5 overflow-y-auto px-5 py-6 text-sm leading-relaxed text-slate-600 sm:px-8" data-testid={`legal-modal-${doc}-body`}>
            <cfg.Content />
          </div>
          <DialogFooter className="flex-col gap-2 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:space-x-0 sm:px-8">
            <a href={cfg.href} target="_blank" rel="noopener noreferrer" data-testid={`legal-modal-${doc}-open-full`}
              className="inline-flex items-center gap-1.5 text-sm font-medium text-cyan-dark underline-offset-4 hover:underline">
              {t("register.openFull")} <ExternalLink className="h-3.5 w-3.5" />
            </a>
            <div className="flex flex-col-reverse gap-2 sm:flex-row">
              <Button type="button" variant="outline" className="rounded-full" onClick={onClose} data-testid={`legal-modal-${doc}-close`}>
                {t("register.close")}
              </Button>
              <Button type="button" className="rounded-full bg-cyan text-white hover:bg-cyan-dark" onClick={() => { onAccept(doc); onClose(); }}
                data-testid={`legal-modal-${doc}-accept`}>
                {t("register.acceptClose")}
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      )}
    </Dialog>
  );
}
